import { render, staticRenderFns } from "./ManageUsersRoles.vue?vue&type=template&id=52ee9368&"
import script from "./ManageUsersRoles.vue?vue&type=script&lang=js&"
export * from "./ManageUsersRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52ee9368')) {
      api.createRecord('52ee9368', component.options)
    } else {
      api.reload('52ee9368', component.options)
    }
    module.hot.accept("./ManageUsersRoles.vue?vue&type=template&id=52ee9368&", function () {
      api.rerender('52ee9368', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/fimalac/components/Modal/ManageUsersRoles.vue"
export default component.exports